import React, { useState, forwardRef, useImperativeHandle } from 'react'
import { Fn } from 'depoto-core'
import { Button } from './shadcn/Button'
import { FormTextarea } from './Form/FormTextarea'
import { Dropdown } from './Dropdown'
import Modal from './Modal'
import { useActiveErrorToasts } from '../hooks/useActiveErrorToasts'
import { toast, type Id } from 'react-toastify'

const errorMsgs = [
  { id: 'empty', name: 'Prázdné' },
  { id: 'missing_address', name: 'Chybí doručovací adresa' },
  { id: 'missing_branch_id', name: 'Chybí číslo pobočky' },
  { id: 'missing_items', name: 'Chybí zboží' },
  { id: 'not_accepted', name: 'Pobočka nepřijímá' },
]
type Props = {
  isShown?: boolean
  isError?: boolean
  note?: string
  onUpdate: Fn
}

export const NoteModal = forwardRef<{ openModal: () => void }, Props>(
  ({ isShown, isError, note: initialNote, onUpdate }, ref) => {
    const [isOpen, setIsOpen] = useState(false)
    const [note, setNote] = useState('')
    const activeErrorToasts = useActiveErrorToasts()

    useImperativeHandle(ref, () => ({
      openModal: () => {
        setIsOpen(true)
        setNote(initialNote || '')
      },
    }))

    const closeModal = () => setIsOpen(false)

    const updateNote = async () => {
      onUpdate(note)
      closeModal()
    }

    const adoptErrorToast = (toastId: Id, text: string) => {
      setNote(text)
      toast.dismiss(toastId)
    }

    return (
      <Modal
        isOpen={isOpen}
        onClose={closeModal}
        title={isError ? 'Upravit chybovou poznámku' : 'Upravit poznámku'}
        className={!isError ? 'overflow-hidden' : ''}>
        <div className="mt-2">
          <FormTextarea label={'Poznámka'} className={'mt-2'} value={note} onChange={n => setNote(n)} />
          {isError && activeErrorToasts.length > 0 && (
            <div className="mt-4">
              <div className="text-sm font-semibold text-gray-600 mb-2">Aktuální chybová hlášení</div>
              <div className="flex flex-col gap-2">
                {activeErrorToasts.map(errorToast => (
                  <Button
                    key={errorToast.id}
                    type="button"
                    size="sm"
                    variant="outline"
                    className="!h-auto min-h-[2.5rem] justify-start whitespace-pre-line break-words text-left"
                    onClick={() => adoptErrorToast(errorToast.id, errorToast.text)}>
                    {errorToast.text}
                  </Button>
                ))}
              </div>
            </div>
          )}
        </div>

        <div className="mt-4 flex justify-end gap-2">
          <div className="mr-12 mt-2">
            <Dropdown
              title={'Předpřipravené'}
              options={errorMsgs}
              hasAllOption={false}
              onChange={val => setNote(val === 'empty' ? '' : errorMsgs.find(m => m.id === val)?.name || '')}
            />
          </div>
          <Button
            onClick={() => updateNote()}
            variant={isError ? 'destructive' : 'default'}
            icon={['fas', 'check']}
            title={isError ? 'Nahlásit chybu' : 'Uložit'}>
            {isError ? 'Nahlásit chybu' : 'Uložit'}
          </Button>
        </div>
      </Modal>
    )
  },
)

NoteModal.displayName = 'NoteModal'
